import { render } from "./EstimatePhaseAttachments.vue?vue&type=template&id=648ad7b6&scoped=true&ts=true"
import script from "./EstimatePhaseAttachments.vue?vue&type=script&lang=ts"
export * from "./EstimatePhaseAttachments.vue?vue&type=script&lang=ts"

import "./EstimatePhaseAttachments.vue?vue&type=style&index=0&id=648ad7b6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648ad7b6"]])

export default __exports__